module.exports = __webpack_public_path__ + "img/plant_6_small.8aae2f92.webp";